define('home/views/ChannelCardFavoriteView',[
    'underscore',

    'home/views/ChannelCardView',
    'home/templates/channelCardFavorite',
], function (
    _,

    ChannelCardView,
    channelCardFavoriteTemplate
) {
    'use strict';

    var ChannelCardFavoriteView = ChannelCardView.extend({
        template: channelCardFavoriteTemplate,

        templateHelpers: function () {
            var data = ChannelCardView.prototype.templateHelpers.apply(this, arguments);
            return _.extend(data, {
                forumHref: '/home/forum/' + this.model.thread.forum.id + '/',
            });
        },
    });

    return ChannelCardFavoriteView;
});

